import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import type { User } from '../types/user.type';

export const GetUserSchema = z.object({
  user_id: z.string().min(1, {
    message: 'id user tidak boleh kosong!',
  }),
});
export type GetUserPayload = z.infer<typeof GetUserSchema>;
export type GetUserResponse = ApiResponse<User>;

export const getUser = async (
  payload: GetUserPayload
): Promise<GetUserResponse> => {
  const { user_id } = payload;
  const url = `user/${user_id}`;

  return await apiClient.get(url);
};

export const GET_USER_QUERY_KEY = 'user';
export function getUserQueryOptions(payload: GetUserPayload) {
  return queryOptions({
    queryKey: [GET_USER_QUERY_KEY, payload.user_id],
    queryFn: () => getUser(payload),
  });
}
